export default "__VITE_ASSET__DbMKXq6z__"